export default "__VITE_ASSET__C1LGpy2w__"